/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * At which point in a usage the damage was reported.
 */
export type DamageDtoPhase = typeof DamageDtoPhase[keyof typeof DamageDtoPhase];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DamageDtoPhase = {
  BEFORE_USAGE: 'BEFORE_USAGE',
  DURING_USAGE: 'DURING_USAGE',
  AFTER_USAGE: 'AFTER_USAGE',
  ADMIN: 'ADMIN',
} as const;
